export const modifiedGranteeAlmostThereContent = {
    heading: 'Almost there! Log in and complete your access request',
    setUpOnlineAccessListItem: 'Set up online access to vanguard.com',
    logInAndEnterPinListItem: 'Log in and enter your unique pin',
    acceptAccessRequestListItem: 'Accept your access request'
}